export default {
  EBWC_WIN: 0,
  EBWC_BIG_WIN: 15,
  EBWC_MEGA_WIN: 30,
}
